const _DEV_ = process.env.NODE_ENV === 'development'
const { REACT_APP_HOST, REACT_APP_PDF_HOST } = process.env

const HOST = _DEV_ ? (REACT_APP_HOST || $HOST) : $HOST
const PDF_HOST = _DEV_ ? (REACT_APP_PDF_HOST || $PDF_HOST) : $PDF_HOST

export {
  HOST,
  PDF_HOST
}